export const HOST_OUTBOUND_EVENTS = Object.freeze({
  LEFT_MEETING: 'left-meeting',
  JOIN_MEETING_ERROR: 'join-meeting-error'
});

export const HOST_INBOUND_EVENTS = Object.freeze({
  SET_AUDIO_STATE: 'set-audio-state',
  SET_VIDEO_STATE: 'set-video-state'
});
